import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';

import { AppComponent } from './app.component';
import { API_BASE_URL } from './constants';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRouterModule } from './app-router.module';
import { UiModule } from './ui/ui.module';
import { AuthInterceptor } from './auth/interceptors/auth.interceptor';
import { ErrorHandlerInterceptor } from './error-handler/error-handler.interceptor';

import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/bg/all';
import { MessageService } from '@progress/kendo-angular-l10n';
import { TranslationsService } from './core/services/translations.service';
import { RefreshTokenInterceptor } from './auth/interceptors/auth-refresh.interceptor';
import { AuthGuard } from './auth/guards/authorize.guard';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const HttpLoaderProvider = {
  provide: TranslateLoader,
  useFactory: HttpLoaderFactory,
  deps: [HttpClient],
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    TranslateModule.forRoot({
      loader: HttpLoaderProvider,
      defaultLanguage: environment.defaultLanguage,
    }),
    AppRouterModule,
    UiModule,
  ],
  providers: [
    { provide: MessageService, useClass: TranslationsService },
    { provide: API_BASE_URL, useValue: environment.backend },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: environment.minutesBeforeTokenExpire ? RefreshTokenInterceptor : AuthInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: ErrorHandlerInterceptor,
    },
    {
      provide: LOCALE_ID,
      useValue: environment.defaultLocale,
    },
    {
      provide: AuthGuard,
      useClass: AuthGuard
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
